$(function() {
 
 $.getJSON('/cart.js', function(cart) {
   if(cart.discount_codes.some(dc => dc.code.includes("HeyStranger-"))) {
       $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: {
      attributes: {
        off10: true
      }
    },
    success: function(cart) {
      console.log('Cart attribute freegift:', cart.attributes.freegift);
    }
  // });
   })
 }

});
})


$(document).ready(function() {
setTimeout(function() {
   var newProduct = $('#newProduct').val();
    var regularPrice = $(".price-affrim-container .regios-dopp-generic-price-item--regular").html().replace("$", "").replace(".00", "");
  console.log('mnop', $(".regios-dopp-generic-price-item--regular").html())
  // Define the HTML to inject
  var rewardPointsHTML = `
    <div class="reward-points">
      <span><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14.47 15.49">
        <defs>
          <style>
            .st0 {
              fill: #2dbcaf;
            }
          </style>
        </defs>
        <path class="st0" d="M7.8,2.02c.98,2.76,3.15,5.02,5.75,6.3.25.13.55.2.8.34.07.03.15,0,.12.12-.01.04-.68.28-.8.34-2.97,1.45-4.46,3.31-5.84,6.24-.03.07,0,.15-.12.12-.04-.01-.28-.68-.34-.8-1.44-2.97-3.33-4.47-6.24-5.85-.06-.03-.15,0-.12-.12.01-.05.79-.33.91-.4,2.18-1.07,4.05-2.84,5.19-4.99.21-.39.36-.88.55-1.23.04-.07,0-.1.13-.08Z"></path>
        <path class="st0" d="M2.51,0c.34.95,1.02,1.64,1.87,2.15.13.08.32.13.44.21.06.04.11,0,.08.13-.86.3-1.59.95-2.07,1.71-.11.18-.19.43-.3.6-.04.06,0,.11-.13.08-.32-.95-1.02-1.65-1.87-2.15-.13-.08-.32-.13-.44-.21-.06-.04-.11,0-.08-.13.65-.24,1.31-.71,1.75-1.26.27-.33.4-.72.62-1.05.04-.06,0-.11.13-.08Z"></path>
      </svg></span>
      Earn ${regularPrice} points.
    </div>
  `;

  // Inject the reward points HTML after the regular price

  if(newProduct == 'false') {
 $(".reward-points").append(rewardPointsHTML);
  }
    }, 2000); 
});


$('.quick-add').click(function() {
   var newContent = $(this).closest('.product-card--card').find('.price.regios-dopp-generic-price-container').clone();
  setTimeout(function() {
$('quick-view[active]').find('.price.regios-dopp-generic-price-container').replaceWith(newContent);
  }, 4000); 

})
$('.size-filter').click(function() {
  $('.facet-wrapper button').click();
$('.details').not('[data-index="drawer-filter.v.option.size"]').attr('open', false).attr('aria-expanded', 'false');
  
$('.details').not('[data-index="drawer-filter.v.option.size"]').find('details__content').attr('style', function(i, style) {
        return style.replace('opacity: 1', 'opacity: 0').replace('opacity: 0', 'opacity: 0');
    });
  $('.details[data-index="drawer-filter.v.option.size"]').attr('open', true).attr('aria-expanded', 'true');

  
})

$('.color-filter').click(function() {
  $('.facet-wrapper button').click();
$('.details').not('[data-index*="color"]').attr('open', false).attr('aria-expanded', 'false');
$('.details').not('[data-index*="color"]').find('details__content').attr('style', function(i, style) {
        return style.replace('opacity: 1', 'opacity: 0').replace('opacity: 0', 'opacity: 0');
    });
    $('.details[data-index*="color"]').attr('open', true).attr('aria-expanded', 'true');
  
})


$(document).on('click', '.lmuLiveButton', function(e){
   $(this).parent().find('.lmuLiveTitle').addClass('activeCard');
})
$(document).on('click', '#lmuEmailSubmitButton', function(e){
  const items = [
  {
    title: "What’s In Everyone’s Carts?",
    list: "UArUvA"
  },
  {
    title: "Addie’s Top 11 for Our 11th!",
    list: "TQbmkG"
  },
  {
    title: "Wear Now: Our Top Outfit Picks",
    list: "VxnJtr"
  },
  {
    title: "The Fan Fave Fit Guide",
    list: "XPyUgR"
  }
];
    let requestData = {};
   requestData.email= $('#lmuEmail').val();
    lists=  items.find(i => i.title === $('.lmuLiveTitle.activeCard').html());
  requestData.list =lists['list'];
setTimeout(function() {
    $.ajax({
      url: `https://sweetlegs.rocks/api/klaviyo/profile`,
       type: 'PATCH',
      	data: requestData,
       success: function (response) {

       },
   });
  }, 60000); 
})
$(document).on('click', '.scr-btn.wlo_try_luck_btn', function(e){
  let requestData = {};
   requestData.email= $('#cfl_email').val();
  setTimeout(function() {
    $.ajax({
      url: `https://sweetlegs.rocks/api/klaviyo/profile`,
       type: 'PATCH',
      	data: requestData,
       success: function (response) {

       },
   });
}, 120000);  // 2000 milliseconds = 2 seconds

// if($('#wl_code_input').val().length > 5) {
//   window.location.href = 'https://www.sweetlegs.ca/discount/$('#wl_code_input').val()';
// }
});





document.addEventListener('DOMContentLoaded', function() {

    // Size Change Event
    document.querySelectorAll('input[name="Size"]').forEach(function(input) {
      if(input) {
        input.addEventListener('change', function() {
            const size = this.getAttribute('modal-size');
            const height = this.getAttribute('modal-height');
            const name = this.getAttribute('modal-name');
            document.querySelector('.modal-name').textContent = name;
            document.querySelector('.modal-height').textContent = height;
            document.querySelector('.modal-size').textContent = size;
            if (name.length > 0) {
                setTimeout(function() {
                    document.querySelector('.product__media.selected .modal-info').classList.remove('hideMe');
                }, 90);
            }
        });
      }
    });

    // Calculate Discount Percentage
  if(document.querySelector('.price-affrim-container .price__sale')) {
    let regularPriceText = document.querySelector('.price-affrim-container .price__sale').textContent.replace('$', '').trim();
    let regularPrice = parseFloat(regularPriceText);
    let salePriceText = document.querySelector('.price-affrim-container .price__regular span').textContent.replace('$', '').trim();
    let salePrice = parseFloat(salePriceText);

    console.log('this hit salePrice, ', salePrice, regularPrice);
    if (regularPrice > salePrice) {
        let discountPercentage = ((regularPrice - salePrice) / regularPrice) * 100;
        discountPercentage = discountPercentage.toFixed(2);
        if (discountPercentage >= 40) {
            document.querySelector('.price-affrim-container .final-sale-tag').classList.remove('hideMe');
        } else {
            document.querySelector('.price-affrim-container .final-sale-tag').classList.add('hideMe');
        }
    } else {
        document.querySelector('.price-affrim-container .final-sale-tag').classList.add('hideMe');
    }
  }

    // Scroll Events
    window.addEventListener('scroll', function() {
        const collectionContent = document.querySelector('.collection__content');
        if (collectionContent) {
            const mnopTop = collectionContent.getBoundingClientRect().top;
            if (mnopTop <= 0) {
                document.querySelector('.facet-sticky').classList.add('visible');
            } else {
                document.querySelector('.facet-sticky').classList.remove('visible');
            }
        }

        const element = document.querySelector('.mobile-dock');
        const intercomFrame = document.querySelector('.intercom-launcher');
        const intercomFrameIframe = document.querySelector('.intercom-launcher-frame');

        if (element && window.innerWidth < 700) {
            const style = getComputedStyle(element);
            if (style.transform === 'none' || style.transform === 'matrix(1, 0, 0, 1, 0, 0)') {
                if (intercomFrame) intercomFrame.classList.add('hideMe123');
                if (intercomFrameIframe) intercomFrameIframe.classList.add('hideMe123');
            } else {
                if (intercomFrame) intercomFrame.classList.remove('hideMe123');
                if (intercomFrameIframe) intercomFrameIframe.classList.remove('hideMe123');
            }
        }
    });

    // Cart Drawer Button Resize Event
    document.querySelector('.cart-drawer-button').addEventListener('click', function() {
        // window.dispatchEvent(new Event('resize'));
    });

    // Tolstoy Widget
    window.tolstoySettings = {
        loadHidden: true,
    };

    // Add to Wishlist
    document.querySelectorAll('#add-to-wishlist').forEach(function(button) {
        button.addEventListener('click', function(event) {
            event.preventDefault();
            const wishlistView = this.closest('wishlist-view');
            const variantId = wishlistView.querySelector('form input[name=id]').value;
            const productId = wishlistView.querySelector('form input[name=product-id]').value;
            const url = wishlistView.querySelector('form input[name=url]').value;
            const imgSrc = wishlistView.querySelector('.product__media img').src;
            const productTitle = wishlistView.querySelector('form input[name=title]').value;

            const product = {
                epi: parseInt(variantId),
                empi: parseInt(productId),
                du: `https://www.sweetlegs.ca${url}`,
                et: 4,
                uri: "https://www.sweetlegs.ca/?_ab=0&_fd=0&_sc=1",
                dt: "Canadian designed leggings & women's wear | SweetLegs",
                ct: "",
                rc: "default",
                type: "product-variant"
            };

            if (window._swat) {
                window._swat.addToWishList(product, function(response) {
                    const content = `<a href="/pages/swym-wishlist" ><div class="swym-product-tile"><button class="swym-close-btn swym-is-button" aria-label="Close Notification"><span class="swym-icon"></span></button><img class="swym-image" src="${imgSrc}" alt=""><div class="swym-details-container"><div class="swym-details" role="alert"><span class="swym-emphasis">${productTitle}</span> has been added to <span class="swym-emphasis">1 list</span> successfully.</div></div></div></a>`;
                    window._swat.ui.uiRef.showSuccessNotification({ message: content });
                    wishlistView.removeAttribute('open');
                    wishlistView.removeAttribute('active');
                    wishlistView.setAttribute('aria-modal', false);
                }, function(error) {
                    wishlistView.removeAttribute('open');
                    wishlistView.removeAttribute('active');
                    wishlistView.setAttribute('aria-modal', false);
                });
            }
        });
    });


    // Show Wishlist Button After Delay
    setTimeout(function() {
      if(document.querySelector('.swym-button.swym-add-to-wishlist-view-product.swym-heart'))
        document.querySelector('.swym-button.swym-add-to-wishlist-view-product.swym-heart').style.display = 'block';
    }, 2000);

    // Image Swatch Hover
    let originalImageSrc = null;
    document.querySelectorAll(".product-card .color-swatch").forEach(function(swatch) {
        swatch.addEventListener('mouseenter', function() {
            const newImageSrc = this.getAttribute('img');
            const parentCard = this.closest('.card.product-card');
            originalImageSrc = parentCard.querySelector('img').src;
            parentCard.querySelector('.media.is-selected img').setAttribute('src', newImageSrc);
            parentCard.querySelector('.media.is-selected img').setAttribute('srcset', newImageSrc);
        });
        swatch.addEventListener('mouseleave', function() {
            const parentCard = this.closest('.card.product-card');
            parentCard.querySelector('.media.is-selected img').setAttribute('src', originalImageSrc);
            parentCard.querySelector('.media.is-selected img').setAttribute('srcset', originalImageSrc);
        });
    });

});
